import {Jsona} from 'jsona';
import {
  TDeserializeOptions,
  TJsonaDenormalizedIncludeNames,
  TJsonaModel,
  TJsonaNormalizedIncludeNamesTree,
  TJsonApiBody,
} from 'jsona/lib/JsonaTypes';
import {OperatorFunction} from 'rxjs';
import {map} from 'rxjs/operators';
import {JsonApiResponse} from '@tisa-group/cdk/models';

const jsona = new Jsona();

export function deserialize<T, R>(
  config: TDeserializeOptions = {},
): OperatorFunction<T, R> {
  return map<T, R>((response: T) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {included, ...properties} = response;

    return {
      /**
       * Prevent duplication of data, since all included
       * elements are resolved within the `data` object.
       */
      ...properties,
      data: jsona.deserialize(response as TJsonApiBody | string, config),
    } as unknown as R;
  });
}

export function serialize({
  stuff,
  includeNames,
}: {
  stuff: TJsonaModel | TJsonaModel[];
  includeNames?: TJsonaDenormalizedIncludeNames | TJsonaNormalizedIncludeNamesTree;
}): TJsonApiBody {
  return jsona.serialize({stuff, includeNames});
}

export function pluckData<T>(): OperatorFunction<JsonApiResponse<T>, T> {
  return map<JsonApiResponse<T>, T>((response: JsonApiResponse<T>) => response?.data);
}

/**
 * Checks whether a JSON:API error response carries a given `meta.key`
 * (e.g. `masking_ip`, `ppv_access` on a stream 403).
 */
export function hasWicketErrorKey(
  error: {error?: {errors?: {meta?: {key?: string}}[]}},
  key: string,
): boolean {
  return (error?.error?.errors || []).some(err => err?.meta?.key === key);
}
